import React, { ReactElement, ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';
import Head from 'next/head';

import { Message } from '@atoms';

export type PageHeaderProps = {
  title?: Message;
  description?: Message;
  ogTitle?: Message;
  ogDescription?: Message;
  ogImage?: string;
};

const TITLE_SUFFIX = ' | Reas.cz';

export const PageHeader = ({
  title,
  description = { id: 'meta.description' },
  ogTitle = { id: 'meta.og.title' },
  ogDescription = { id: 'meta.og.description' },
  ogImage = require('@public/static/img/default-og-image.png'),
}: PageHeaderProps) => {
  // UTILS
  const head = (comp: ReactNode) => <Head>{comp}</Head>;
  const messageResolve = (
    message: Message | undefined,
    handler: (text: any) => ReactElement<any, string> | null,
  ) => {
    if (!message) {
      return null;
    }
    if (message.id) {
      return <FormattedMessage {...message}>{handler}</FormattedMessage>;
    }
    if (message.text) {
      return handler(message.text);
    }
    return null;
  };

  return (
    <>
      {/* TITLE */}
      {messageResolve(title, (t) =>
        head(<title>{t ? `${t}${TITLE_SUFFIX}` : t}</title>),
      )}
      {/* DESCRIPTION */}
      {messageResolve(description, (t) =>
        head(<meta name="description" content={t as string} />),
      )}
      {/* OG TITLE */}
      {messageResolve(ogTitle, (t) =>
        head(<meta property="og:title" content={t} />),
      )}
      {/* OG DESCRIPTION */}
      {messageResolve(ogDescription, (t) =>
        head(<meta property="og:description" content={t as string} />),
      )}
      {/* OG IMAGE */}
      {ogImage && head(<meta property="og:image" content={ogImage} />)}
    </>
  );
};
